import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { MatButtonModule } from '@angular/material/button';

export interface Result {
  navigateAwayAndDiscard?: boolean;
}

@Component({
  selector: 'email-unsaved-changes-dialog',
  templateUrl: './unsaved-changes-dialog.component.html',
  styleUrls: ['./unsaved-changes-dialog.component.scss'],
  imports: [TranslateModule, MatDialogModule, MatButtonModule],
})
export class UnsavedChangesDialogComponent {
  constructor(private readonly ref: MatDialogRef<UnsavedChangesDialogComponent>) {}

  close(result: Result = {}): void {
    this.ref.close(result);
  }
}
